import { IconAlertCircle } from '@tabler/icons-react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import EmptyStub from '@/components/ui/EmptyStub';
import Loader from '@/components/ui/Loader';
import { organizationsStore } from '@/stores/global/RootStore';

/* HOC для страниц, для которых нужны организации */
export const withOrganizations = <P extends Record<string, unknown>>(Component: React.ComponentType<P>) =>
  observer((props: P) => {
    const {
      fetchOrganizations,
      meta: { isError, isLoaded, isStaleLoaded },
    } = organizationsStore;

    React.useEffect(() => {
      if (!isLoaded) {
        fetchOrganizations();
      }
    }, [isLoaded, fetchOrganizations]);

    if (!isStaleLoaded) {
      return <Loader fullHeight />;
    }

    if (isError) {
      return (
        <EmptyStub
          title="Не удалось получить список организаций"
          picture={<IconAlertCircle size={50} color="var(--mantine-color-red-6)" />}
          description="Попробуйте позже"
        />
      );
    }

    return <Component {...props} />;
  });
